import { useMemo } from "react";

import useQuery from "../search/useQuery";
import QUERY_TAGS from "../search/queryTags";
import { fetchBanks, fetchMobileMoneyOperators } from "./financeService";
import { mapBank, mapOperator } from "./financeMappers";
import { pickList } from "./financePage";
import { TAXONOMY_STALE_TIME } from "./financeCache";

export const WITHDRAWAL_COUNTRY = "GH";

const useBankingOptions = ({ kind, enabled = true, countryCode = WITHDRAWAL_COUNTRY } = {}) => {
  const isBank = kind === "BANK";

  const query = useQuery({
    key: enabled && kind ? `finance:${isBank ? "banks" : "operators"}:${countryCode}` : null,
    tag: isBank ? QUERY_TAGS.BANKING_BANKS : QUERY_TAGS.BANKING_OPERATORS,
    staleTime: TAXONOMY_STALE_TIME,
    enabled,
    fetcher: () => (isBank ? fetchBanks(countryCode) : fetchMobileMoneyOperators(countryCode)),
  });

  const options = useMemo(() => {
    const rows = pickList(query.currentData, isBank ? "banks" : "operators");

    return rows.map(isBank ? mapBank : mapOperator).filter((row) => row.code);
  }, [query.currentData, isBank]);

  return {
    options,
    isLoading: query.currentData === undefined && !query.isError && query.enabled,
    isError: query.isError,
    error: query.error,
  };
};

export default useBankingOptions;
